import { DeviceEnum, Category, NAVCode } from './ModemDevice';

export interface ProductModel    {
    i_product: number;
    Name: string;
    ProductName: string;
    Caption: string;
    Price: number;
    FundPrice: number;
    Validity: number;
    Subscriptions: SubscriptionInfo[];
    MaintenanceFee: number | null;
    Display: DisplayInfo; 
    Devices: DevicePriceInfo[];
    Category: CategoryInfo;
    ExtraDataBundle: ExtraDataBundleInfo[];
    WeekdayPeriod: string;
    WeekendPeriod: string;
    IsReady: boolean | null;
    new(): ProductModel;

    OperatorID: number | null;
    NAVPostingGroup: string;
    ProductType: ProductType;
    i_account_role: number;
    voip_id_tariff: number;
    StaticIP_i_product: number;
    DisplayName:string;
    
}

export interface DeviceElement {
    i_product: number;
    Device:    string;
    Price:     number;
    Category:  Category;
    NAVCode:   NAVCode;
    NAVPrice:  number;
    Name: string;
    id: number;
}

export interface SubscriptionInfo
{
    i_subscription: number;
    Name: string;
    Price: number;
    Period: SubscriptionPeriodInfo;
    i_product: number;
}

export interface ExtraDataBundleInfo
{
    i_product: number;
    DataCapacity: DataCapacityInfo;
    DisplayName: string;
    Price: number;
}
export enum ValidityPeriodInfo { Days, Months, Quarters, Years }

export enum SubscriptionPeriodInfo { Daily, Weekly, Biweekly, Monthly }

export enum ProductType { Normal, ActivationBundle, PostPaid, Promotion }

export interface DisplayInfo
{
    TimeSlot: string;
    BustableSpeed: string;
    DataCapacity: DataCapacityInfo;
    ValidityPeriod: ValidityPeriodInfo;
    ConnectableDeviceCount: string;
    TargetCustomerClass: string;
    NoofAllowedModems: number;
    ShowonSelfcare: boolean;
    CanRenew: boolean;
    FreeDomainRegistration: boolean | null;
    FreeEmails: boolean | null;
    FreeBrowsingPeriod: string;
}

export interface DataCapacityInfo
{
    Capacity: number;
    UnitofMeasure: DataUnitofMeasureInfo;
}

export interface DevicePriceInfo
{
    i_product: number;
    Device: string;
    Price: number;
    Category: string;
    NAVCode: string;
    NAVPrice: number;
    Name:string;
    id:number;
}

export enum DataUnitofMeasureInfo {
    Byte, KB, MB, GB, TB, NB, PB, EB, ZB, Unlimited
}

export enum CategoryInfo {
    RETAIL_INTERNET,
    ENTERPRISE_INTERNET,
    HOTSPOT,
    VPN,
    VSAT,
    VOICE,
    SMS
}